import { PvpStats } from "../types/battle"

export function formatWinRate(winRate: number | null | undefined): string {
  if (winRate == null || !Number.isFinite(winRate)) return "—"
  const rounded =
    Math.abs(winRate - Math.round(winRate)) < 0.05
      ? Math.round(winRate)
      : Math.round(winRate * 10) / 10
  return `${rounded}%`
}

export function formatCardPvpRecord(stats: PvpStats | undefined): string | null {
  if (!stats) return null
  const battles = stats.pvpBattles ?? stats.pvpWins + stats.pvpLosses + stats.pvpDraws
  if (battles <= 0) return null
  const wr = formatWinRate(stats.winRate)
  return `${stats.pvpWins}В / ${stats.pvpLosses}П${stats.pvpDraws > 0 ? ` / ${stats.pvpDraws}Н` : ""} · ${wr}`
}

export function formatElementStatLine(
  wins: number,
  losses: number,
  winRate: number | null
): string {
  const wr = formatWinRate(winRate)
  return `${wins}В / ${losses}П — ${wr}`
}
